import React, { useContext, useEffect, useState } from "react";
import "./widgetcss/styles.css";
import { MapContext } from "../MapContext";
import "../Judumas.css"

// Clear buttonas reiktu pervadinti
export default function ClearButton({customString = "Nėra parinktų gatvių", enableButtonManually = false}) {
  const mapContext = useContext(MapContext);
  const [enableButton, setEnableButton] = useState(false);

  function dispatchQuery() {
    if (mapContext.state.dateRange !== null) {
      mapContext.dispatch({
        clearFlag: 1,
      });
      
    } else if (mapContext.state.compareTask === 2) {
      mapContext.dispatch({
        clearFlag: 1,
      });
    } else if (enableButton === true) {
      mapContext.dispatch({
        clearFlag: 1,
      });
    }
  }

  function waitForElm(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelectorAll(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          resolve(document.querySelectorAll(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  useEffect(() => {
    //console.log("CLEAR")
    if (mapContext.state.clearFlag === 1) {
      return;
    }
    waitForElm(".ready1").then((button) => {
      button.forEach((nav) => nav.classList.remove("active"));
    });
  }, [mapContext.state.clearFlag]);

  useEffect(() => {
    if (enableButtonManually === false && mapContext.state.selectedStreetArray.length == 0 && mapContext.state.compareDate === null && mapContext.state.dateRange === null) {
      setEnableButton(false);
    }
    else {
      setEnableButton(true);
    }
  }, [mapContext.state.selectedStreetArray, mapContext.state.compareDate, mapContext.state.dateRange, enableButtonManually]);


  return (
    <div className="Footer">
      <div className="">
        {enableButton === false ? (
          <button className="ClearBtn Disabled" disabled onClick={() => {}}>
            {customString}
          </button>
        ) : (
          <button
            className="ClearBtn"
            onClick={() => {
              dispatchQuery();
            }}
          >
            Išvalyti pasirinkimą
          </button>
        )}
      </div>
    </div>
  );
}
